<div class="fog" [style.width]="fogWidth()">
  <div class="cloud"></div>
  <div class="cloud"></div>
  <div class="cloud"></div>
  <div class="cloud"></div>
  <div class="cloud"></div>
</div>
<div id="gameContainer"
     [style.width]="gameWidth"
     [class.flash]="flashError()"
></div>

<div id="offline-resources" class="hidden">
  <img id="offline-resources-1x" src="sheep-100.png" alt="sheep-100">
  <img id="offline-resources-2x" src="sheep-200.png" alt="sheep-100">
  <div class="icon-disable"></div>
  <div class="icon-offline"></div>
</div>
